// Little Islander: carry Printify personalization into the cart.
//
// The Printify personalizer (app embed, cross-origin iframe on personalize.at) posts
// PERSONALIZATION_APPLIED with { personalizationId, timestamp, imageUrl } and then adds only
// properties[Personalization ID] to every /cart/add form. It never passes the typed text back,
// so the customer types the engraving once, inside Printify, and the preview image is their
// confirmation.
//
// This script:
// - remembers imageUrl per personalizationId and writes it to the hidden property
//   "_Personalization preview" (the leading underscore keeps it out of checkout and customer
//   property lists; the cart templates read it for the thumbnail);
// - on products listed in snippets/printify-personalized-product.liquid, blocks add-to-cart until
//   a Printify design is saved, and confirms when it is;
// - shows the saved preview on the gallery slide of the selected option.
// Printify's own Personalization ID input is never touched.
(function () {
  if (window.__liPersonalizationPreview) return;
  window.__liPersonalizationPreview = true;

  var PREVIEW_PROPERTY = 'properties[_Personalization preview]';
  var ID_PROPERTY = 'properties[Personalization ID]';
  var PREVIEW_PREFIX = 'https://personalize.at/api/personalisation/product/';
  var previewsById = {};

  var MESSAGES = {
    noDesign: 'Please click Personalize This Item and save your design before adding to cart.',
    saved: String.fromCharCode(0x2713) + ' Your personalized preview is saved.',
    otherOption:
      'Each option is personalized separately. Click Personalize This Item to save your design for this option.',
  };
  // Set once a design has been saved on this page, so a later option change can explain why the
  // newly selected option asks for its own design.
  var designSavedThisPage = false;

  function statusLine() {
    var root = document.querySelector('[data-li-personalization]');
    if (!root) return null;
    return {
      root: root,
      message: root.querySelector('[data-li-personalization-message]'),
      productId: root.dataset.productId,
    };
  }

  // kind 'ok' is a neutral confirmation; anything else shows as an error.
  function showMessage(status, text, kind) {
    status.message.textContent = text;
    status.message.hidden = !text;
    status.message.classList.toggle('text-red', kind !== 'ok');
  }

  function cleanUrl(url) {
    // Drop Printify's cache-buster so the stored value is stable for the same design.
    return url.replace(/([?&])_t=\d+&?/, '$1').replace(/[?&]$/, '');
  }

  // When the customer returns to an option it saved, Printify appends that option's ID without
  // removing the one already in the form. Shopify keeps the last value, so the newest input is the
  // design that will be ordered; drop the stale ones so the preview always matches it.
  function savedDesignId(form) {
    var idInputs = form.querySelectorAll('input[name="' + ID_PROPERTY + '"]');
    if (!idInputs.length) return '';
    for (var i = 0; i < idInputs.length - 1; i++) idInputs[i].remove();
    return idInputs[idInputs.length - 1].value;
  }

  function isPersonalizedForm(form, status) {
    var productInput = form.querySelector('input[name="product-id"]');
    return !!status && !!productInput && productInput.value === status.productId;
  }

  function syncForm(form) {
    var id = savedDesignId(form);
    var preview = (id && previewsById[id]) || null;
    var input = form.querySelector('input[name="' + PREVIEW_PROPERTY + '"]');
    if (!preview) {
      if (input) input.remove();
      return;
    }
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = PREVIEW_PROPERTY;
      form.appendChild(input);
    }
    input.value = preview;
  }

  function block(event, status) {
    event.preventDefault();
    event.stopImmediatePropagation();
    showMessage(status, MESSAGES.noDesign);
    // The sticky add-to-cart bar can be far below this line.
    status.message.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }

  window.addEventListener('message', function (event) {
    if (event.origin !== 'https://personalize.at') return;
    var message = event.data;
    if (!message || message.type !== 'PERSONALIZATION_APPLIED' || !message.data) return;
    var id = message.data.personalizationId;
    var url = message.data.imageUrl;
    if (!id) return;
    if (typeof url === 'string' && url.indexOf(PREVIEW_PREFIX) === 0) previewsById[id] = cleanUrl(url);
    designSavedThisPage = true;
    var status = statusLine();
    if (status) showMessage(status, MESSAGES.saved, 'ok');
  });

  // Printify puts its preview into the first product photo it finds, which in this theme's
  // slider is the first slide, not the photo of the selected option. Put Printify's swap back
  // and show the preview on the selected slide instead.
  var shownPreview = null; // { img, src, srcset } of the slide currently showing the preview

  function hidePreview() {
    if (!shownPreview) return;
    shownPreview.img.src = shownPreview.src;
    shownPreview.img.srcset = shownPreview.srcset;
    shownPreview = null;
  }

  function undoPrintifySwap() {
    var swapped = document.querySelectorAll('img[data-original-src]');
    for (var i = 0; i < swapped.length; i++) {
      var img = swapped[i];
      if (img.src.indexOf(PREVIEW_PREFIX) !== 0) continue;
      img.src = img.dataset.originalSrc;
      delete img.dataset.originalSrc;
      delete img.dataset.currentSrc;
    }
  }

  // The photo of the selected option: the selected slide, or the only photo when there is no slider.
  function selectedPhoto(status) {
    var section = status.root.closest('.shopify-section') || document;
    var selected = section.querySelector('.f-product__media.is-selected img');
    if (selected) return selected;
    var photos = section.querySelectorAll('.f-product__media img');
    return photos.length === 1 ? photos[0] : null;
  }

  function showPreview(img, url) {
    if (shownPreview && shownPreview.img === img) {
      if (img.src !== url) img.src = url;
      return;
    }
    hidePreview();
    shownPreview = { img: img, src: img.src, srcset: img.srcset };
    img.srcset = '';
    img.src = url;
  }

  // Printify keeps one saved design per product option: it removes the Personalization ID input
  // when the customer picks another option and puts it back when they return to one it saved.
  // Keep the status line and the product photo truthful as that input comes and goes.
  function refreshStatus() {
    var status = statusLine();
    if (!status) return;
    var id = '';
    var form = null;
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      if (!isPersonalizedForm(forms[i], status)) continue;
      form = form || forms[i];
      id = savedDesignId(forms[i]) || id;
    }
    // Without a photo to move it to, leave Printify's own swap in place.
    var photo = selectedPhoto(status);
    if (photo) {
      undoPrintifySwap();
      if (id && previewsById[id]) showPreview(photo, previewsById[id]);
      else hidePreview();
    }
    if (!designSavedThisPage || !form) return;
    showMessage(status, id ? MESSAGES.saved : MESSAGES.otherOption, 'ok');
  }

  var refreshTimer = null;
  function isIdInput(node) {
    return node.nodeType === 1 && node.matches && node.matches('input[name="' + ID_PROPERTY + '"]');
  }
  new MutationObserver(function (records) {
    var touched = records.some(function (record) {
      return (
        Array.prototype.some.call(record.addedNodes, isIdInput) ||
        Array.prototype.some.call(record.removedNodes, isIdInput)
      );
    });
    if (!touched) return;
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshStatus, 150);
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener(
    'click',
    function (event) {
      var status = statusLine();
      if (!status || !event.target.closest) return;
      // Printify's button reads "Remove" while a design is saved; removing it voids the confirmation.
      var personalize = event.target.closest('[id^="personalize-button"]');
      if (personalize && (personalize.getAttribute('onclick') || '').indexOf('clearPersonalization') !== -1) {
        designSavedThisPage = false;
        showMessage(status, '');
        return;
      }
      var buyNow = event.target.closest('.shopify-payment-button__button');
      var form = buyNow && buyNow.closest('form[action*="/cart/add"]');
      if (form && isPersonalizedForm(form, status) && !savedDesignId(form)) block(event, status);
    },
    true
  );

  // Capture phase runs before the theme's own submit handler builds its FormData.
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
      var status = statusLine();
      if (isPersonalizedForm(form, status) && !savedDesignId(form)) {
        block(event, status);
        return;
      }
      syncForm(form);
    },
    true
  );
})();
